'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BBBOZKTU.mjs";

// src/price/PriceTag.tsx
import { jsx } from "react/jsx-runtime";
var PriceTagIcon = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    __spreadProps(__spreadValues({
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.33301 8.27614V1.33333H8.27582L14.9425 8L7.99967 14.9428L1.33301 8.27614ZM4.99967 6C5.55196 6 5.99967 5.55229 5.99967 5C5.99967 4.44772 5.55196 4 4.99967 4C4.44739 4 3.99967 4.44772 3.99967 5C3.99967 5.55229 4.44739 6 4.99967 6Z",
          fill: "currentColor"
        }
      )
    })
  );
};

export {
  PriceTagIcon
};
//# sourceMappingURL=chunk-D6R77JOL.mjs.map